export const enum PageTypeEnum {
  HoABL = "5001",
  Investments = "5002",
  Promises = "5003",
  Portfolio = "5004",
  Profile = "5005",
  FooterTabs = "5006",
}
